export enum ConsentType {
    PlainText = 'plain-text',
    Privacy = 'privacy',
}
